export default {
  metadata: {
    version: '1.0.0',
    id: 'file-uploader-panel-1.0.0',
    name: 'JDSFileUploaderPanel'
  },
  hierarchy: {
    container: [
      'jds_file_uploader_item',
      {
        'inner-container': ['jds_progress_bar']
      },
      'jds_file_uploader_list'
    ]
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      width: '{f_3}',
      opacity: '{f_4}',
      'background-color': '{f_5}',
      'border-radius': '{f_6}',
      'padding-top': '{f_7}',
      'padding-bottom': '{f_8}'
    },
    'inner-container': {
      hidden: true,
      'padding-top': '{f_9}',
      'padding-bottom': '{f_10}',
      'padding-left': '{f_11}',
      'padding-right': '{f_12}',
      width: '{f_13}'
    },
    jds_file_uploader_item: {
      hidden: true
    },
    jds_progress_bar: {
      kind: 'determinate',
      flex: 1
    }
  },
  variant: {
    kind: {
      collapsible: {
        jds_file_uploader_item: {
          hidden: false
        },
        'inner-container': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      collapsible: {
        false: {
          jds_file_uploader_item: {
            kind: 'collapsed'
          },
          jds_file_uploader_list: {
            hidden: true
          }
        },
        true: {
          jds_file_uploader_item: {
            kind: 'expanded'
          },
          jds_file_uploader_list: {
            hidden: false
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'expanded']],
  api: {
    config: {
      kind: {
        values: ['classic', 'collapsible']
      },
      expanded: {
        values: [false, true]
      },
      showDivider: {
        values: [true, false]
      }
    },
    data: {
      jds_file_uploader_item: {
        message: {
          type: 'string',
          name: 'message'
        }
      },
      jds_progress_bar: {
        value: {
          type: 'float',
          name: 'value'
        }
      },
      jds_file_uploader_list: {
        showDivider: {
          type: 'boolean',
          name: 'showDivider'
        },
        items: {
          type: 'list',
          name: 'items',
          object: {
            state: 'JDSFileUploaderItem.state',
            message: 'string'
          }
        }
      }
    },
    events: {
      jds_file_uploader_item: {
        onClick: 'onClick'
      },
      jds_file_uploader_list: {
        onClick: 'onClose'
      }
    },
    a11y: {
      jds_file_uploader_list: {
        name: 'items',
        repeating: {
          itemAriaLabel: 'itemAriaLabel',
          itemAriaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_file_uploader_item: {
        properties: {
          ariaLabel: 'panelAriaLabel',
          ariaDescribedby: {
            name: 'panelAriaDescribedBy',
            platform: 'web,ios'
          },
          suffixAriaLabel: {
            name: 'panelSuffixAriaLabel',
            value: 'Toggle Files List'
          },
          ariaExpanded: {
            name: '_ariaExpanded',
            prop: 'expanded'
          }
        }
      }
    }
  }
};
